export const verifyAccountId = (id: string) => /[a-z\d]{4,}/.test(id);
export const verifyPassword = (password: string) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(password);
export const verifyKeyExisted = (targetEnum: object, value: string): boolean =>
	!!Object.keys(targetEnum).find((key) => key === value);
